export const groupNpiRecordDetailsByCategory = (npiRecord, ...categories) =>
  Object.entries(npiRecord).reduce((acc, pair, idx) => {
    const index_string = pair[0].match(
      RegExp(`(?<=(${categories.join("|")})[a-z_]+)\\d+`)
    )?.[0];
    const key = pair[0].match(
      RegExp(`^(${categories.join("|")})[a-z_]*(?=_\\d)`)
    )?.[0];
    const value = pair[1];

    if (index_string && key && value) {
      const index = parseInt(index_string) - 1;
      acc[index] = { ...acc[index], ...{ key: idx, [key]: value } };
    }

    return acc;
  }, []);

export default groupNpiRecordDetailsByCategory;
